import type { GetFacetsParams } from '../types'

export function getFacetScope(params: GetFacetsParams, compactNavigation: boolean): GetFacetsParams {
  return compactNavigation ? { ...params, premium: undefined, level: undefined } : params
}
